/**
 * Company Details Utility
 * Reads company branding details from environment variables (.env.development)
 * Supports both local files and external URLs for logo and favicon
 */

const getCompanyLogo = () => {
  const logoPath = process.env.REACT_APP_COMPANY_LOGO || "companyLogo.svg";
  
  // If it's an external URL (http or https), return it as-is
  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath;
  }
  
  // Otherwise, try to load from local assets/images folder
  try {
    return require(`assets/images/${logoPath}`).default || require(`assets/images/${logoPath}`);
  } catch (error) {
    // Fallback to default logo if file not found
    return require('assets/images/companyLogo.svg').default || require('assets/images/companyLogo.svg');
  }
};

const getCompanyLogoDark = () => {
  const logoPath = process.env.REACT_APP_COMPANY_LOGO_DARK || "companyLogoDark.png";
  
  // If it's an external URL (http or https), return it as-is
  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath;
  }
  
  // Otherwise, try to load from local assets/images folder
  try {
    return require(`assets/images/${logoPath}`).default || require(`assets/images/${logoPath}`);
  } catch (error) {
    // Fallback to default dark logo if file not found
    return require('assets/images/companyLogoDark.png').default || require('assets/images/companyLogoDark.png');
  }
};

const getCompanyLogoLight = () => {
  const logoPath = process.env.REACT_APP_COMPANY_LOGO_LIGHT || "companyLogoLight.png";
  
  // If it's an external URL (http or https), return it as-is
  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath;
  }
  
  // Otherwise, try to load from local assets/images folder
  try {
    return require(`assets/images/${logoPath}`).default || require(`assets/images/${logoPath}`);
  } catch (error) {
    // Fallback to default light logo if file not found
    return require('assets/images/companyLogoLight.png').default || require('assets/images/companyLogoLight.png');
  }
};

const getCompanyFavicon = () => {
  const faviconPath = process.env.REACT_APP_COMPANY_FAVICON || "/favicon.ico";
  
  // If it's an external URL (http or https), return it as-is
  if (faviconPath.startsWith('http://') || faviconPath.startsWith('https://')) {
    return faviconPath;
  }
  
  // Otherwise return as local path
  return faviconPath;
};

export const companyDetailsEnum = {
    companyName: process.env.REACT_APP_COMPANY_NAME || "RentnGo-subvendor",
    companyLogo: getCompanyLogo(),
    companyLogoDark: getCompanyLogoDark(),
    companyLogoLight: getCompanyLogoLight(),
    favicon: getCompanyFavicon()
}